import useWidth from '@/helpers/widthUtil';
import React, { createContext, useState } from 'react';
import EnquiryForm from './EnquiryForm';
import AbroadPerks from './Perks';
import { message, Modal } from 'antd';
import EnquiryOtpForm from './EnquiryOtpForm';
import axios from 'axios';
declare global {
  interface Window {
    recaptchaVerifier: any;
    confirmationResult: any;
  }
}
const LearnsicAbroad = () => {
  const { isMobile, isTablet } = useWidth();
  const [isOtpFormVisible, setIsOtpFormVisible] = useState<boolean>(false);
  const [formData, setFormData] = useState<any>({ country_code: '+977' });
  const [OTP, setOTP] = useState('');
  const [disableResend, setDisableResend] = useState(false);

  const processSendMessage = () => {
    setIsOtpFormVisible(false);
    try {
      axios
        .post(
          `${process.env.NEXT_PUBLIC_SIC_URL}ask-question/?ref=Learnsic Abroad`,
          formData
        )
        .then((response) => {
          setFormData(null);
          message.success('Enquiry sent successfully');
          setFormData({ country_code: '+977' });
        });
    } catch (error) {
      message.error('Failed to send enquiry');
    }
  };

  return (
    <AbroadContext.Provider
      value={{
        formData,
        setFormData,
        OTP,
        setOTP,
        processSendMessage,
        disableResend,
        setDisableResend,
        setIsOtpFormVisible,
      }}
    >
      <div className="custom-container">
        <Modal
          visible={isOtpFormVisible}
          onCancel={() => setIsOtpFormVisible(false)}
          footer={null}
          style={{ zIndex: '1500' }}
        >
          <EnquiryOtpForm />
        </Modal>

        <div
          className={`about-us-container ${
            !isMobile ? 'mt-25 mb-100' : 'mt-3 mb-5 pl-3 pr-3'
          }`}
        >
          <div className={`row ${isMobile || isTablet ? 'flex-column mt-4' : ''}`}>
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="p-4 bg-white rounded shadow mt-4">
                {!isMobile && (
                  <div style={{ fontWeight: '700', fontSize: '22px' }}>
                    Have Questions?
                  </div>
                )}
                <span className="d-block">
                  Get free and detailed counseling from experts on your study
                  journey.
                </span>
                <EnquiryForm />
              </div>
            </div>
            {!isMobile && (
              <div className="col-lg-6 col-md-12 col-sm-12">
                <AbroadPerks />
              </div>
            )}
          </div>
        </div>
      </div>
      <div id="recaptcha-container"></div>
    </AbroadContext.Provider>
  );
};

export default LearnsicAbroad;

export const AbroadContext = createContext<any>({});
